import { apiConstants } from "../../config";
import {
  apiPost,
  apiPut,
  apiGet,
  apiDelete
} from "../../../../shared/services";
import Vue from "vue";

const fetchItems = async options => {
  const url = apiConstants.url;
  return await apiGet(url, { params: options });
};

const saveItem = async (id, data, validator) => {
  if (id) {
    let url = apiConstants.url + "/" + id;
    return await apiPut(url, { ...data }, validator);
  } else {
    let url = apiConstants.url;
    return await apiPost(url, { ...data }, validator);
  }
};

const fetchItem = async id => {
  const url = apiConstants.url;
  return await apiGet(url + "/" + id);
};

const fetchMyFamily = async () => {
  const url = apiConstants.myFamily;
  return await apiGet(url);
};

const fetchConfirmations = async () => {
  const url = apiConstants.confirmations;
  return await apiGet(url);
};

const deleteItem = async id => {
  const url = apiConstants.url;
  return await apiDelete(url + "/" + id);
};

const sendRegistration = async (id, data, validator) => {
  let url = apiConstants.sendRegistration + "/" + id;
  return await apiPost(url, { ...data }, validator);
};

const saveRegistration = async (id, data, validator) => {
  let url = apiConstants.saveRegistration + "/" + id;
  return await apiPut(url, { ...data }, validator);
};

const deleteRegistration = async id => {
  const url = apiConstants.registration;
  return await Vue.axios.delete(url + "/" + id);
};

const saveChildren = async (id, data, validator) => {
  if (id) {
    let url = apiConstants.myFamilyChildren + "/" + id;
    return await apiPut(url, { ...data }, validator);
  } else {
    let url = apiConstants.myFamilyChildren;
    return await apiPost(url, { ...data }, validator);
  }
};

const saveParent = async (id, data, validator) => {
  if (id) {
    let url = apiConstants.myFamilyParent + "/" + id;
    return await apiPut(url, { ...data }, validator);
  } else {
    let url = apiConstants.myFamilyParent;
    return await apiPost(url, { ...data }, validator);
  }
};

/*const deleteChildren = async id => {
  const url = apiConstants.url;
  return await apiDelete(url + "/" + id);
};*/

export {
  fetchItems,
  saveItem,
  deleteItem,
  fetchItem,
  fetchMyFamily,
  sendRegistration,
  deleteRegistration,
  saveChildren,
  saveRegistration,
  saveParent,
  fetchConfirmations
};
